import EventsHandler from "../service/events";
import EVENTS from "../constants/events";

export class NavigationToggleComponent
{
    private $root:JQuery;
    private events:EventsHandler;

    constructor(element:HTMLElement) {
        this.$root = $(element);
    }

    protected init() {
        this.bindUI();
    }

    protected bindUI() {
        this.$root.on({ click: this.handleClick });
        this.events.addListener(EVENTS.MENU_OPEN, this.handleMenuOpen);
        this.events.addListener(EVENTS.MENU_CLOSE, this.handleMenuClose);
    }

    protected handleClick = (ev:any) => {
        ev.preventDefault();
        this.events.emit('true' === this.$root.attr('aria-expanded') ? EVENTS.MENU_CLOSE : EVENTS.MENU_OPEN);
    }

    protected handleMenuOpen = () => {
        this.$root
            .addClass('is-open')
            .attr('aria-expanded', 'true')
        ;
    }

    protected handleMenuClose = () => {
        this.$root
            .removeClass('is-open')
            .attr('aria-expanded', 'false')
        ;
    }

    public setEventHandler(events:EventsHandler) {
        this.events = events;
        return this;
    }
}